import DateIconSvg from '../../assets/icons/date.svg?react';
import type { CSSProperties } from 'react';

export interface IconProps {
    size?: number | string;
    className?: string;
    style?: CSSProperties;
    onClick?: () => void;
}

const DateIcon: React.FC<IconProps> = ({ 
    size = 16, 
    className = '', 
    style = {},
    onClick 
}) => {
    const iconStyle: CSSProperties = {
        width: typeof size === 'number' ? `${size}px` : size,
        height: typeof size === 'number' ? `${size}px` : size,
        display: 'inline-block',
        fill: 'currentColor',
        ...style,
    };

    return (
        <DateIconSvg 
            className={className}
            style={iconStyle}
            onClick={onClick}
        />
    );
};

export default DateIcon;
